import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JustBetHomepgeComponent } from './just-bet-homepge/just-bet-homepge.component';
import { LiveBettingComponent } from './live-betting/live-betting.component';
import { SportsBettingComponent } from './sports-betting/sports-betting.component';
import { VirtualBettingComponent } from './virtual-betting/virtual-betting.component';
import { HomeScreenComponent } from './home-screen/home-screen.component';
import { GuyanaHomeScreenComponent } from './guyana-home-screen/guyana-home-screen.component';
import { ChatbotWorkspaceComponent } from './common/chatbot-workspace/chatbot-workspace.component';

const routes: Routes = [
  // { path: '', redirectTo: 'quote-engine', pathMatch: 'full' },
  { path: '', redirectTo: 'home-screen', pathMatch: 'full' },
  { path: 'numbers', loadChildren: './numbers/numbers.module#NumbersModule' },
  { path: 'cashpot', loadChildren: './cashpot-game/cashpot-game.module#CashpotGameModule'},
  // { path: 'post-winning-numbers', loadChildren: './post-winning-numbers/post-winning-numbers.module#PostWinningNumbersModule'},
  { path: 'ticket-payout', loadChildren: './ticket-payout/ticket-payout.module#TicketPayoutModule' },
  { path: 'tickets-voids', loadChildren: './tickets-voids/tickets-voids.module#TicketsVoidsModule' },
  { path: 'winning-list', loadChildren: './winning-list/winning-list.module#WinningListModule' },
  { path: 'barcode-scanner', loadChildren: './barcode-scanner/barcode-scanner.module#BarcodeScannerModule' },
  { path: 'winning-numbers', loadChildren: './winning-numbers/winning-numbers.module#WinningNumbersModule'},
  { path: 'administration', loadChildren: './administration/administration.module#AdministrationModule' },
  { path: 'panel', loadChildren: './panel-management/panel-management.module#PanelManagementModule' },
  { path: 'reporting', loadChildren: './reporting/reporting.module#ReportingModule' },
  { path: 'customer', loadChildren: './consumer/consumer.module#ConsumerModule' },
  { path: 'back-office', loadChildren: './back-office/back-office.module#BackOfficeModule' },
  { path: 'application', loadChildren: './application/application.module#ApplicationModule' },
  { path: 'reports', loadChildren: './reports/reports.module#ReportsModule' },
  { path: 'games', loadChildren: './games/games.module#GamesModule' },
  { path:'kiosk-new',loadChildren:'./kiosk/kiosk.module#KioskModule'},
  { path:'kiosk',loadChildren:'./kiosk-blue-theme/kiosk-blue-theme.module#KioskBlueThemeModule'},
  { path: 'referral-module', loadChildren: './referral-module/referral-module.module#ReferralModuleModule' },
  { path: 'bglc-reports', loadChildren: './bglc-reports/bglc-reports.module#BglcReportsModule' },
  { path: 'edufocal', loadChildren: './edufocal/edufocal.module#EdufocalModule' },
  { path: 'voucher', loadChildren: './voucher/voucher.module#VoucherModule' },
  { path: 'ready-credit', loadChildren: './ready-credit/ready-credit.module#ReadyCreditModule' },
  { path: 'blinksky', loadChildren: './blinksky/blinksky.module#BlinkskyModule' },
  { path: 'gli-reports', loadChildren: './gli-reports/gli-reports.module#GliReportsModule' },
  { path: 'fintech', loadChildren: './fintech/fintech.module#FintechModule' },
  { path: 'platform-reports', loadChildren: './platform-reports/platform-reports.module#PlatformReportsModule' },
  { path: 'svl-services', loadChildren: './svl-services/svl-services.module#SvlServicesModule' },
  { path: 'platform-configurations', loadChildren: './platform-configurations/platform-configurations.module#PlatformConfigurationsModule' },
  { path: 'mbet', loadChildren: './horse-racing/horse-racing.module#HorseRacingModule' },
  { path: 'mmg', loadChildren: './mmg-reports/mmg-reports.module#MmgReportsModule' },
  { path: 'prelive', component: SportsBettingComponent },
  { path: 'virtualsport', component: VirtualBettingComponent },
  { path: 'live', component: LiveBettingComponent },
  { path: 'just-bet-homepage', component: JustBetHomepgeComponent },
  { path: 'utilities', loadChildren: './utilities/utilities.module#UtilitiesModule' },
  { path: 'chatbot-workspace', component: ChatbotWorkspaceComponent },
  { path: 'home-screen', component: HomeScreenComponent },
  { path: 'guyana-home-screen', component: GuyanaHomeScreenComponent },
  { path: 'guyana-reports', loadChildren: './guyana-reports/guyana-reports.module#GuyanaReportsModule' },
  { path: 'kiosk-device-management', loadChildren: './kiosk-device-management/kiosk-device-management.module#KioskDeviceManagementModule' },
  { path: 'icasino-reports', loadChildren: './icasino-reports/icasino-reports.module#IcasinoReportsModule' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
